module.exports = __webpack_public_path__ + "img/fa01.1e9de4a0.jpg";